export default __webpack_public_path__ + "16155b04d7618a1ad88c35c10d419283.png";